/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import { getCartState, getCurrentCartState, isCartLoadedWithLines } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import loadPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import {
    chain,
    PreloadData,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/PreloadCheckoutShippingData";

export const xngPreloadData: any = (props: any) => {
    const state = props.getState();

    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }

    if (!getAddressFieldsDataView(state).value) {
        props.dispatch(loadAddressFields());
    }
    const expand = state.data.carts.cartApiParameter?.expand || [];

    if (props.parameter.cartId) {
        const cartState = getCartState(state, props.parameter.cartId);

        if (!isCartLoadedWithLines(cartState)) {
            props.dispatch(
                loadCart({ cartId: props.parameter.cartId, dontExpandFull: props.parameter.dontExpandFull } as any),
            );
        }

        if (!getPromotionsDataView(state, props.parameter.cartId).value) {
            props.dispatch(loadPromotions({ cartId: props.parameter.cartId }));
        }
    } else {
        const currentCartState = getCurrentCartState(state);

        if (!isCartLoadedWithLines(currentCartState)) {
            props.dispatch(loadCurrentCart());
        }

        if (!getCurrentPromotionsDataView(state).value) {
            props.dispatch(loadCurrentPromotions());
        }
    }
};

replaceInChain(chain, PreloadData, xngPreloadData);
